import { HIGHLIGHTS } from "@/data/project";
import { Store, Fuel, Building2, Car } from "lucide-react";

const ICONS = {
  0: Store,
  1: Fuel,
  2: Building2,
  3: Car,
};

const Highlights = () => {
  return (
    <section
      id="proyecto"
      data-testid="highlights-section"
      className="relative py-24 md:py-32 bg-[var(--co-primary)] text-white overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-40" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-[var(--co-accent-light)] uppercase tracking-[0.25em] text-xs font-semibold">
              <span className="h-px w-8 bg-[var(--co-accent-light)]" />
              04 · El proyecto
            </span>
            <h2 className="mt-6 font-display text-white text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
              Más que una plaza.
              <br />
              <span className="text-[var(--co-accent-light)]">Un destino diario.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-10">
            <p className="text-white/75 text-lg leading-relaxed">
              Costa Oeste Plaza combina un supermercado ancla, estación de combustible y 19 locales
              comerciales en dos niveles. Diseño moderno, accesos amplios y 74 estacionamientos.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {HIGHLIGHTS.map((h, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={h.title}
                data-testid={`highlight-${i}`}
                className="bg-[var(--co-primary)] p-8 md:p-10 hover:bg-[var(--co-primary-dark)] transition-colors duration-300 group"
              >
                <Icon className="w-8 h-8 text-[var(--co-accent-light)] group-hover:scale-110 transition-transform" />
                <p className="mt-6 font-display text-2xl md:text-3xl font-bold leading-tight">
                  {h.title}
                </p>
                <p className="mt-2 text-[var(--co-accent-light)] text-sm font-semibold tracking-wider uppercase">
                  {h.area}
                </p>
                <p className="mt-4 text-white/70 text-sm leading-relaxed">{h.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
